class HeaderSearch extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    const body = document.querySelector('body')

    this.els.input.element.addEventListener('focus', () => {
      body.classList.add('util-SearchFocus')
    })

    this.externalEls.trigger.element.addEventListener('click', (e) => {
      body.classList.add('util-SearchFocus')
      this.els.input.element.focus()
    })

    body.addEventListener('click', (e) => {
      if (
        e.target === this.externalEls.trigger.element ||
        e.target.closest(this.externalEls.trigger.selector)
      ) return
      if (e.target === this.els.input.element) return
      if (e.target.closest('.klevu-fluid')) return

      body.classList.remove('util-SearchFocus')
    })
  }
}

customElements.define('header-search', HeaderSearch)
